import React, { useState } from 'react';
import { Container, Box, ThemeProvider } from '@mui/material';
import PhoneInput from './components/PhoneInput';
import Chat from './components/Chat/index.tsx';
// import Chat from './components/Chat';
import { ChatProvider } from './context/ChatContext';
import theme from './theme';
import './App.css';
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');

  const continueAsGuest = () => {
    let sessionId = Math.random().toString(36).substring(7);
    sessionStorage.setItem('sessionId', sessionId);
    setIsAuthenticated(true);
  };

  return (
    <ThemeProvider theme={theme}>
      <ChatProvider>
        {sessionStorage.getItem("sessionId") || isAuthenticated ?
          <Chat phoneNumber={phoneNumber} /> :
          <PhoneInput
            onSubmit={(phone) => {
              setPhoneNumber(phone);
              setIsAuthenticated(true);
            }}
            onGuestClick={continueAsGuest}
          />
        }
      </ChatProvider>
    </ThemeProvider>
  );
}

export default App;